<div class="apg-panel" [appScrollIntoView]="true">
  <div class="capture-address">
    <h1>Address</h1>

    <app-address-selector [(address)]="address" [disabled]="loading"></app-address-selector>

    <div *ngIf="loading" class="loading">
      <ion-spinner></ion-spinner>
      Saving address...
    </div>

    <div class="summary__buttons" *ngIf="address">
      <ion-button (click)="back.emit()" [disabled]="loading">
        <ion-icon name="chevron-back-outline"></ion-icon>
        Back
      </ion-button>

      <ion-button (click)="proceed()" [disabled]="clientAccessRestricted || loading">
        Continue
        <ion-icon name="chevron-forward-outline"></ion-icon>
      </ion-button>
    </div>
  </div>
</div>
